module.exports = "dist/images/block-seller-block-panel-image.82b89ff.png";